import React from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useHealthMetrics } from '../../hooks/useHealthMetrics';

export function HealthMonitorButton() {
  const navigate = useNavigate();
  const metrics = useHealthMetrics();

  // Calculate metrics out of range
  const outOfRange = [
    metrics.hrv.current < metrics.hrv.yesterday,
    metrics.recovery < 70,
    metrics.strain.current > metrics.strain.optimal.max,
    metrics.sleep.score < 85,
    metrics.readiness < 70
  ].filter(Boolean).length;

  const handleClick = () => {
    navigate('/vitals');
  };

  return (
    <motion.button
      onClick={handleClick}
      className="w-full relative group overflow-hidden"
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      {/* Siri-like Glow Container */}
      <div className="relative p-[1px] rounded-lg">
        {/* Animated Border */}
        <div className="absolute inset-0 rounded-lg animate-siri-glow">
          <div className="absolute inset-0 bg-gradient-to-r from-primary/30 via-purple-500/30 to-primary/30 rounded-lg animate-border-flow" />
        </div>

        {/* Inner Content */}
        <div className="relative bg-background rounded-lg p-3">
          {/* Ambient Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-purple-500/5 to-transparent opacity-30" />
          
          {/* Content */}
          <div className="relative flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="relative">
                <Activity className="w-4 h-4 text-primary" />
                <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
              </div>
              <div className="text-left">
                <div className="text-xs font-medium">Vitals</div>
                <div className="text-xs text-muted-foreground hidden sm:block">Vital Signs</div>
                <div className="text-xs text-muted-foreground sm:hidden">
                  {outOfRange === 0 ? (
                    <span className="text-success">All metrics optimal</span>
                  ) : (
                    <span className="text-warning">{outOfRange}/5 need attention</span>
                  )}
                </div>
              </div>
            </div>
            <div className="text-xs text-primary sm:block hidden">Monitor Now</div>
          </div>
        </div>
      </div>
    </motion.button>
  );
}